import { motion } from "framer-motion";
import { Reveal, SectionHeader } from "./Reveal";
import { experiences } from "../../data/content";

const ExperienceItem = ({ exp, index }) => (
  <div className="relative pl-8 md:pl-12 pb-14 last:pb-0" data-testid={`experience-item-${index}`}>
    {/* line + node */}
    <span className="absolute left-0 top-2 h-3 w-3 rounded-full bg-cyan shadow-[0_0_12px_rgba(0,229,255,0.6)]" />
    <span className="absolute left-[5.5px] top-6 bottom-0 w-px bg-white/10" />

    <div className="flex flex-wrap items-baseline gap-x-4 gap-y-1 mb-1">
      <span className="text-[11px] uppercase tracking-[0.25em] text-cyan/80">{exp.type}</span>
      <span className="text-sm text-[var(--muted)]">{exp.dates}</span>
    </div>
    <h3 className="font-display font-medium text-2xl md:text-3xl leading-tight">{exp.poste}</h3>
    <p className="text-[var(--text-2)] mt-1 mb-4">{exp.organisation}</p>

    <motion.div
      whileHover={{ borderColor: "rgba(0,229,255,0.3)" }}
      className="bg-surface border border-white/5 rounded-2xl p-6 md:p-7 transition-colors duration-300"
    >
      <p className="text-[var(--text-2)] leading-relaxed mb-5">{exp.contexte}</p>
      <div className="grid md:grid-cols-2 gap-6">
        <div>
          <p className="text-xs uppercase tracking-[0.2em] text-white/60 mb-3">Missions principales</p>
          <ul className="space-y-2">
            {exp.missions.map((m, i) => (
              <li key={i} className="text-sm text-[var(--text-2)] flex gap-2">
                <span className="text-cyan mt-0.5">—</span> {m}
              </li>
            ))}
          </ul>
        </div>
        <div>
          <p className="text-xs uppercase tracking-[0.2em] text-white/60 mb-3">Compétences mobilisées</p>
          <div className="flex flex-wrap gap-2 mb-5">
            {exp.competences.map((c, i) => (
              <span key={i} className="text-xs border border-white/10 rounded-full px-3 py-1 text-[var(--text-2)]">{c}</span>
            ))}
          </div>
          <p className="text-xs uppercase tracking-[0.2em] text-white/60 mb-2">Résultats</p>
          <p className="text-sm text-[var(--text-2)] italic">{exp.resultats}</p>
        </div>
      </div>
    </motion.div>
  </div>
);

export const Experience = () => (
  <section id="experiences" className="relative py-24 md:py-32 border-t border-white/5">
    <div className="max-w-5xl mx-auto px-6 md:px-12">
      <SectionHeader index="03" kicker="Expériences" title="Un parcours en" italic="construction." />
      <div className="mt-4">
        {experiences.map((exp, i) => (
          <Reveal key={i} delay={0.05}>
            <ExperienceItem exp={exp} index={i} />
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
